import React from "react";
import styles from "./TooltipGlodal.module.sass";
import { Tooltip as ReactTooltip } from "react-tooltip";

const TooltipGlodal = () => {
    return (
        <ReactTooltip
            id="react-tooltip"
            className={styles.tooltipWpapper}
            place="top"
            style={{
                backgroundColor: "#272B30",
                color: "#F4F4F4",
                border: "1px solid rgba(255, 255, 255, 0.12)"
            }}
        />
    );
};

export default TooltipGlodal;
